// src/data/demoData.js - LISTO PARA PRODUCCIÓN
export const USUARIOS_INIT = [
  // Mantenemos SOLO este usuario temporal para que puedas entrar mientras armamos el backend
  { id: 1, nombre: "Administrador", email: "admin@cardiohard.com", password: "admin", rol: "Administrador", activo: true }
];

export const EQUIPOS_INIT = [];
export const TICKETS_INIT = [];
export const REPUESTOS_INIT = [];
export const PRESUPUESTOS_INIT = [];
export const AUDITORIAS_INIT = [];
export const KPI_HISTORIA = [
  { mes: "Ene", tasa: 78, tiempo: 5.2 },
  { mes: "Feb", tasa: 82, tiempo: 4.8 },
  { mes: "Mar", tasa: 79, tiempo: 5.5 },
  { mes: "Abr", tasa: 85, tiempo: 4.5 },
  { mes: "May", tasa: 83, tiempo: 5.1 },
  { mes: "Jun", tasa: 86, tiempo: 4.9 },
];
export const MOVIMIENTOS_STOCK_INIT = [];
export const HISTORIAL_EQUIPOS_INIT = [];